import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * ToastProvider - Context provider for managing toast notifications
 * @ownyou/ui-components
 */
import { useState, useCallback, useContext, createContext } from 'react';
import { Toast } from './Toast';
const ToastContext = createContext(null);
let toastCounter = 0;
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return ctx;
}
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const dismiss = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);
    const toast = useCallback((opts) => {
        const id = `toast-${++toastCounter}`;
        const duration = opts.duration ?? 5000;
        setToasts((prev) => {
            const next = [...prev, { id, variant: opts.variant, title: opts.title, message: opts.message, duration }];
            // Max 5 toasts
            if (next.length > 5) {
                return next.slice(next.length - 5);
            }
            return next;
        });
        // Auto-dismiss
        if (duration > 0) {
            setTimeout(() => {
                dismiss(id);
            }, duration);
        }
    }, [dismiss]);
    return (_jsxs(ToastContext.Provider, { value: { toast, dismiss }, children: [children, _jsx("div", { className: "fixed bottom-4 right-4 z-50 flex flex-col gap-2", children: toasts.map((t) => (_jsx(Toast, { variant: t.variant, title: t.title, message: t.message, onDismiss: () => dismiss(t.id) }, t.id))) })] }));
}
export default ToastProvider;
